module.exports = __webpack_public_path__ + "img/homebannerbg2.6dd1a558.png";